var _classCallCheck = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var MessageTracker =
/*#__PURE__*/
function () {
  "use strict";

  function MessageTracker() {
    _classCallCheck(this, MessageTracker);

    this.messages = [];
  }

  _createClass(MessageTracker, [{
    key: "exists",
    value: function exists(envelope, protocol) {
      var msgRecord = this.messages[envelope.id];
      return !!msgRecord; //if(!protocol || !msgRecord) return false;
      //return msgRecord[protocol] !== undefined;
    }
  }, {
    key: "push",
    value: function push(envelope, protocol) {
      if (!this.messages[envelope.id]) this.messages[envelope.id] = {};
      this.messages[envelope.id][protocol] = envelope[1]; // TTL

      return envelope.id;
    }
  }, {
    key: "isSent",
    value: function isSent(envelope) {
      return this.messages[envelope.id].sent;
    }
  }, {
    key: "sent",
    value: function sent(envelope) {
      this.messages[envelope.id].sent = true;
    }
  }]);

  return MessageTracker;
}();

module.exports = MessageTracker;